import { Component, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { IToast, ToastService } from '@static/services/toast.service';

@Component({
  selector: 'app-toast',
  imports: [
    MatProgressSpinnerModule,
  ],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})
export class ToastComponent {
  private _toastService: ToastService = inject(ToastService);
  public toasts: IToast[];

  constructor() {
    this.toasts = this._toastService.toasts;

    this._toastService.toastUpdate.subscribe(() => {
      this.toasts = this._toastService.toasts;
    });
  }

  /**
   * Dismiss a toast
   *
   * @param uid toast uid
   */
  public closeToast(uid: number): void {
    this._toastService.removeToast(uid);
  }

}
